import { render, staticRenderFns } from "./FrequentlyCalledNumbers.vue?vue&type=template&id=43328d29&"
import script from "./FrequentlyCalledNumbers.vue?vue&type=script&lang=js&"
export * from "./FrequentlyCalledNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports